import WorkFeaturedList from './WorkFeaturedList';

export default WorkFeaturedList;
